import React, { useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FetchResourcePoolFilters } from "services/pendingService";
import { FetchResourcePoolData } from "../../services/onholdService";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
  getSubdomain,
} from "helpers/utils";
import { RangeSlider } from "rsuite";
import { Button, Spinner } from "reactstrap";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isEmpty } from "lodash";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import cross from "../../assets/images/icon/cross.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import Dropdown from "react-bootstrap/Dropdown";
import moment from "moment";
import { decryptDataFromArray } from "helpers/EncDec";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";
import { getCityListAPI } from "helpers/backend_helper";

function AllApplications(props) {
  const getDashboardFilterData = key => {
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (!key || !payloadObj?.filterValue) {
      return;
    }
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    return dashboardFilters?.[key] || "";
  };
  const [cityOptions, setCityOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { t } = useTranslation();
  const [dataList, setDataList] = useState([]);
  const [filters, setFilters] = useState({});
  const [filterData, setFiltersData] = useState({
    genderTypes: [],
    jobTitles: [],
    jobOpenings: [],
    jobExpectedTimes: [],
    jobModes: [],
    sourceList: [],
    uniqueCities: [],
    applicationStages: [],
    vacancyTypes: [],
  });
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [query, setQuery] = useState("");
  const tableRef = useRef(null);
  const [startDate, setStartDate] = useState(
    getDashboardFilterData("startDate")
      ? new Date(getDashboardFilterData("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    getDashboardFilterData("endDate")
      ? new Date(getDashboardFilterData("endDate"))
      : ""
  );
  const [type, setType] = useState(getDashboardFilterData("type") || "");
  const history = useHistory();
  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [csvData, setCSVData] = useState([]);
   const tableWrapperRef = useRef(null);
    const tabWrapperRef = useRef(null);

  const getApplicationList = async (
    current = 1,
    size = 10,
    query_text = "",
    sort_field = sortField,
    sort_order = sortOrder
  ) => {
    setLoading(true);
    await FetchResourcePoolData({
      filters: {
        ...filters,
        application_stage: filterData?.applicationStages?.filter(
          elem => elem.value !== "partial"
        ),
      },
      startDate: startDate,
      endDate: endDate,
      type: type,
      page: current,
      queryText: query_text,
      pageSize: size,
      ...(sort_field && { sortField: sort_field, sortOrder: sort_order }),
    })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setDataList(responseData?.data);
          setTotalCounts(responseData.total_counts);

          if (responseData?.data?.length) {
            tableRef?.current?.scrollIntoView();
          }
        } else {
          toast.error(t(`all-application.No data available`));
        }

        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        let errMsg =
          err?.response?.data?.message ||
          t(`all-application.Something Went Wrong`);
        toast.error(errMsg);
      });
  };

  const handleSearchCity = async text => {
    setSearchText(text);

    if (text.length < 2) return; // avoid unnecessary API calls

    try {
      const res = await getCityListAPI(text);

      if (res?.status) {
        setCityOptions(res.data.cities || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = async () => {
              // console.log("SEARCH CLICKED"); 
              // console.log("applicationStages:", filterData.applicationStages);
    // if (filterData.applicationStages.length > 0) {
      handleSubmit();
      setCurrentPage(1);
    // }
  };

  useEffect(() => {
    getFilterInfo();
    getApplicationList();
    document.title = "NeuroTal - All Applications";
  }, []);

  useEffect(() => {
    if (filterData.applicationStages.length > 0) {
      handleSubmit();
    }
  }, [filterData]);

  const getFilterInfo = async () => {
    let filterValues = {};
    await FetchResourcePoolFilters()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        let filtersData = responseData?.data || "";
        setFiltersData(filtersData);
        filterValues = filtersData;
      })
      .catch(err => {});
    return filterValues;
  };

  function calculateDaysAgo(applyDate) {
    const applyDateObj = new Date(applyDate);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - applyDateObj;

    // Convert milliseconds to days (1000 ms in a second, 60 seconds in a minute, 60 minutes in an hour, 24 hours in a day)
    const daysAgo = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return daysAgo;
  }

  const cityColumn = {
    dataField: "master_city.city",
    text: t(`all-application.City`),
    classes: "application-normal",
  };

  const columns = [
    {
      dataField: "appl_id",
      text: t(`all-application.Appl No`),
      classes: "total app-col sticky-col",
      headerClasses: "app-col sticky-col",
      attrs: { "data-th": "Appl. No" },
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row?.apply_date);
        const formattedDate =
          row?.appl_id +
          "/" +
          (applyDate?.getMonth() + 1) +
          "" +
          applyDate?.getFullYear();
        return (
          <div className="date-tabel">
            <label>{formattedDate}</label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`all-application.Name`),
      classes: "application-name name-col sticky-col",
      headerClasses: "name-col sticky-col",
      attrs: { "data-th": "Name" },
      sort: true,
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell.toLowerCase()}
        </span>
      ),
    },
    {
      dataField: "email_id",
      text: t(`all-application.Email Id`),
      classes: "application-email ",
      attrs: { "data-th": "Email Id" },
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "mobile",
      text: t(`all-application.Mobile No`),
      classes: "application-normal",
      attrs: { "data-th": "Mobile No" },
      formatter: (cell, row) => <>{generateMaskedPII(row?.mobile, 2)}</>,
    },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      classes: "application-normal educations",
      attrs: { "data-th": "Education" },
      sort: true,
    },
    {
      dataField: "job_user.total_experience",
      text: t(`all-application.Total Exp`),
      classes: "application-normal",
      attrs: { "data-th": "Total Exp" },
      sort: true,
    },
    {
      dataField: "vacancy.title",
      text: t(`all-application.Job Role`),
      headerClasses: "application-normal education",
      classes: "application-normal education",
      attrs: { "data-th": "Job Role" },
      sort: true,
    },
     {
      dataField: "vacancy_franchise_franchise_name",
     text: t(`all-application.dealer_name`),
      headerClasses: "application-normal education",
      classes: "application-normal education",
      attrs: { "data-th": "Job Role" },
      sort: false,
    },
    ...(getSubdomain() !== "mahindra" ? [cityColumn] : []),
    {
      dataField: "apply_date",
      text: t(`all-application.Applied on`),
      classes: "application-normal",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const today = new Date();
        const isToday = applyDate.toDateString() === today.toDateString(); // Compare date parts only

        const daysAgo = calculateDaysAgo(applyDate);

        return (
          <div className="date-tabel">
            <label>
              {isToday
                ? t(`all-application.Today`)
                : `${daysAgo} ${t(`all-application.days ago`)}`}
            </label>
          </div>
        );
      },
    },

    //  {
    //     dataField: "creator.name",
    //     text: t(`all-application.created_by`),
    //     classes: "application-normal",
    //   },

    {
      dataField: "currentStage",
      text: t(`all-application.Current Stage`),
      classes: "application-normal",
      attrs: { "data-th": "Current Stage" },
    },
    {
      dataField: "",
      attrs: { "data-th": "Actions" },
      text: t(`all-application.Actions`),
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        return (
          <div className="action-application">
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  aria-label="Open menu"
                >
                  <img src={threedots} alt="Menu" />
                  {/* Optional: Text for accessibility if needed */}
                  {/* <span className="sr-only">Open menu</span> */}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={
                      !checkPermissionStatus("all-applications", "view")
                    }
                    onClick={() => {
                      history.push(
                        `/candidate_consolidate/view-details/${appl_id}`
                      );
                    }}
                  >
                    {t(`all-application.View Details`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`all-application.Showing rows`, { from, to, size })}
    </span>
  );

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 7) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }
    return baseClass;
  };

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (dataList.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [dataList.length]);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleSubmit = async (action, defaultFilters, defaultType) => {
    let typeValue = type;
    let filterObj = filters;
    if (action === "remove") {
      typeValue = defaultType;
      filterObj = defaultFilters;
    }
    setLoading(true);
    await FetchResourcePoolData({
      filters: {
        ...filterObj,
        application_stage: filterData?.applicationStages?.filter(
          elem => elem.value !== "partial"
        ),
      },
      startDate: startDate,
      endDate: endDate,
      type: typeValue,
      page: currentPage,
      queryText: query,
      pageSize: sizePerPage,
    })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData.status) {
          setDataList(responseData?.data);
          setTotalCounts(responseData.total_counts);

          if (responseData?.data?.length) {
            tableRef?.current?.scrollIntoView();
          }
        } else {
          toast.error(t(`all-application.No data available`));
        }

        setLoading(false);
        setIsVisible(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        let errMsg =
          err?.response?.data?.message ||
          t(`all-application.Something Went Wrong`);
        toast.error(errMsg);
      });
  };

  const handleInput = (e, name) => {
    setFilters({
      ...filters,
      [name]: e,
    });
  };

  const toggleFilter = () => {
    setIsVisible(!isVisible);
  };

  const clearFilters = () => {
    setFilters({});
    setStartDate("");
    setEndDate("");
    setType("");
    setQuery("");
    setCurrentPage(1);
    setSizePerPage(10);
    setIsVisible(false);
    handleSubmit("remove", {}, "");
  };

  const getFilterCount = () => {
    let countValue = Object.values(filters)?.filter(el => !isEmpty(el))?.length;
    let typeValue = type === "" ? 0 : 1;
    return countValue + typeValue;
  };

  const handleGenderChange = (e, val, id) => {
    let name = e.target.name;
    let value = e.target.checked;
    if (value) {
      let oldGenderValues = filters?.gender || [];
      oldGenderValues.push({ label: name, value: val, id: id });
      setFilters({
        ...filters,
        gender: oldGenderValues,
      });
    } else {
      let oldGenderValues = filters?.gender || [];
      oldGenderValues = oldGenderValues?.filter(el => el?.value !== name);
      setFilters({
        ...filters,
        gender: oldGenderValues,
      });
    }
  };

const getFilterList = () => {
  let allFilters = JSON.parse(JSON.stringify(filters));

  let filterArray = Object.keys(allFilters)?.map(el => {
    let label = el?.split("_")?.join(" ");
    let values = allFilters[el];

    if (el !== "relevancy_score" && el !== "age") {
      values = values?.map(item => item?.label)?.join(", ");
    } else {
      values = values?.join(" to ");
    }

    return {
      label: label,
      value: values,
      key: el,
    };
  });

  if (type !== "") {
    filterArray.push({
      label: t(`all-application.Date Range`),
      value:
        type === "current"
          ? t(`all-application.Current Month`)
          : type === "previous"
          ? t(`all-application.Last 3 Months`)
          : `Custom (${moment(getCompanyTimezoneDateTime(startDate)).format(
              "DD MMM YYYY"
            )} - ${moment(getCompanyTimezoneDateTime(endDate)).format(
              "DD MMM YYYY"
            )})`,
      key: "type",
    });
  }

  return filterArray;
};

  const handleFilterRemove = key => {
    let defaultFilters = filters;
    let defaultType = type;
    if (key === "type") {
      setType("");
      defaultType = "";
    } else {
      let allFilters = JSON.parse(JSON.stringify(filters));
      delete allFilters[key];
      defaultFilters = allFilters;
      setFilters(allFilters);
    }
    handleSubmit("remove", defaultFilters, defaultType);
  };

  if (!checkPermissionStatus("all-applications", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`all-application.Access Denied`)}</h4>
      </div>
    );
  }

  /**table arrow */
 
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

 

  const scrollLeft = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = isLang1OrLang2 ? 30 : 20; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = isLang1OrLang2 ? 30 : 20;
    } else if (window.innerWidth < 1280) {
      moveDistance = isLang1OrLang2 ? 60 : 50;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = 150; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth >= 1280) {
      // Adjust based on lang-1 or lang-2
      if (bodyClassList.contains("lang-1")) {
        moveDistance = 380; // For lang-1
      } else if (bodyClassList.contains("lang-2")) {
        moveDistance = 100; // For lang-2
      } else {
        moveDistance = 380; // Default for 1280px+
      }
    } else if (window.innerWidth >= 1152) {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    } else {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const handleTableChange = (type, { page, sizePerPage: ps, sortField: sf }) => {
    if (type === "sort") {
      const newOrder = sf === sortField
        ? (sortOrder === "asc" ? "desc" : "asc")
        : "asc";
      setSortField(sf);
      setSortOrder(newOrder);
      setCurrentPage(1);
      getApplicationList(1, ps || sizePerPage, query, sf, newOrder);
    } else {
      setCurrentPage(page);
      setSizePerPage(ps);
      getApplicationList(page, ps, query, sortField, sortOrder);
    }
  };
  const handleCSVDownload = async e => {
    e.preventDefault();

    let csvParentData = [];
    try {
      await FetchResourcePoolData({
        filters: filters,
        startDate: startDate,
        endDate: endDate,
        type: type,
        queryText: query,
        isCsvDownload: true,
      })
        .then(res => {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);
          csvParentData = responseData?.data || [];
       let allData = (JSON.parse(JSON.stringify(csvParentData)) || [])?.map(item => {
  return {
    ...item,
    email_id: generateMaskedPII(item?.email_id),
    mobile: generateMaskedPII(item?.mobile, 2),
  };
});

          setCSVData(allData || []);
          setTimeout(() => {
            let element = document.getElementById("downloadCSV");
            element.click();
          }, 1000);

          setLoading(false);
          toast.success("File downloaded successfully.");
        })
        .catch(err => {
          setLoading(false);
          let errMsg =
            err?.response?.data?.message ||
            t(`all-application.Something Went Wrong`);
          toast.error(errMsg);
        });
    } catch (error) {
      console.error("Error fetching application data:", error);
    }
  };

  console.log("cityOptions", cityOptions);

  return (
    <>
      <div className="pending-list-page">
        <div className="tabbing-wrapper allapplication-cards  allap d-flex justify-content-between mt-2 mb-4 position-relative">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul
              className="tab-btn-wrapper d-flex align-items-center"
              ref={tabWrapperRef}
              style={{ transition: "transform 0.3s" }}
            >
              {checkPermissionStatus("/all-applications", "view") && (
                <li>
                  <Link
                    to={`/all-applications${type ? "?filterValue=true" : ""}`}
                    className="tab-link active"
                    id="all-applications"
                  >
                    {t(`all-application.All Applications`)}
                  </Link>
                </li>
              )}

              {checkPermissionStatus("/pending-list", "view") && (
                <li>
                  <Link
                    to={`/pending-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="pending-list"
                  >
                    {t(`all-application.New Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/screening-list", "view") && (
                <li>
                  <Link
                    to={`/screening-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="screening-list"
                  >
                    {t(`all-application.In Progress Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/selected-list", "view") && (
                <li>
                  <Link
                    to={`/selected-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="selected-list"
                  >
                    {t(`all-application.Selected Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/onboarded-list", "view") && (
                <li>
                  <Link
                    to={`/onboarded-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="onboarded-list"
                  >
                    {t(`all-application.Onboarded Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/onhold-list", "view") && (
                <li>
                  <Link
                    to={`/onhold-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="onhold-list"
                  >
                    {t(`all-application.Onhold Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/rejected-list", "view") && (
                <li>
                  <Link
                    to={`/rejected-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="rejected-list"
                  >
                    {t(`all-application.Rejected Applications`)}
                  </Link>
                </li>
              )}
              {checkPermissionStatus("/archive-list", "view") && (
                <li>
                  <Link
                    to={`/archive-list${type ? "?filterValue=true" : ""}`}
                    className="tab-link"
                    id="archive-list"
                  >
                    {t(`all-application.Archived Applications`)}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search">
                  <div className="total-record d-flex gap-3 align-items-center">
                    <h5>
                      {t(`all-application.Total Records`)}{" "}
                      <span>{totalCounts || 0}</span>
                    </h5>
                  </div>
                  <div className="d-flex gap-3 align-items-center right-rows">
                    <SearchBar
                      onSearch={handleSearch}
                      title={t(`all-application.Search by mobile2`)}
                      placeholder={
                        t(`all-application.Search by mobile`).slice(0, 40) +
                        "..."
                      }
                      query={query}
                      setQuery={setQuery}
                    />
                    <div>
                      {checkPermissionStatus(
                        "all-applications",
                        "downloadcsv"
                      ) && (
                        <div className="take-text">
                          <CSVLink
                            // data={dataList?.filter(renderCheck)}
                            data={csvData}
                            headers={[
                              {
                                key: "appl_id",
                                label: t(`all-application.Application ID`),
                              },
                              {
                                key: "name",
                                label: t(`all-application.Name`),
                              },
                              {
                                key: "mobile",
                                label: t(`all-application.Mobile Number`),
                              },
                              {
                                key: "email_id",
                                label: t(`all-application.Email ID`),
                              },
                              {
                                key: "vacancy.title",
                                label: t(`all-application.Job Role`),
                              },
                              {
                                key: "vacancy_franchise_franchise_name",
                                label: 'Dealer',
                              },
                              {
                                key: "master_city.city",
                                label: t(`all-application.Job Location`),
                              },
                              {
                                key: "currentStage",
                                label: t(`all-application.Current Stage`),
                              },
                            ]}
                            filename={`AllApplicationList.csv`}
                            id="downloadCSV"
                          >
                            <Button
                              color="info"
                              onClick={e => handleCSVDownload(e)}
                              outline
                            >
                              <img src={dowanload_csv} alt="Download" />{" "}
                              {t(`all-application.Download CSV`)}
                            </Button>
                          </CSVLink>
                        </div>
                      )}
                    </div>
                    <div
                      className="take-text filter"
                      onClick={() => toggleFilter()}
                    >
                      <h5>
                        <span>
                          <img src={filtericon} alt="" />
                        </span>
                        {t(`all-application.Filters`)}{" "}
                        {getFilterCount() !== 0 ? `(${getFilterCount()})` : ""}
                      </h5>
                    </div>

                    <div className="tale-text right-panel alapp arrow-btns">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                {getFilterList()?.length > 0 && (
                  <div className="selected-data-card length-selected-data  allapp mb-4">
                    {getFilterList()?.map((el, index) => {
                      return (
                        <div className="select-para" key={index}>
                          <p className="mb-0">
                            <span className="selected-tag text-capitalize">
                              {el?.label} - {el?.value}
                            </span>
                            <button
                              className="remove-tag-button"
                              onClick={() => handleFilterRemove(el?.key)}
                            >
                              &times;
                            </button>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* <div className="timeto-hire-card userlist allapplication-po nosdatat"> */}
                <div className="timeto-hire-card userlist">
                  {loading && (
                    <div className="m-3 p-3 text-center">
                      <Spinner size={"lg"} />{" "}
                      <div>{t(`all-application.Loading`)}</div>
                    </div>
                  )}
                  {!loading && (
                    <div className="table-custome-class range-custome">
                      {dataList?.length > 0 ? (
                        <>
                          <div className="scroll-container">
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <RemotePagination
                                keyField="appl_id"
                                data={dataList}
                                columns={columns}
                                page={currentPage}
                                sizePerPage={sizePerPage}
                                totalSize={totalCounts}
                                onTableChange={handleTableChange}
                                rowClasses={rowClasses}
                                sortField={sortField}
                                sortOrder={sortOrder}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{t(`all-application.Appl No`)}</th>
                              <th>{t(`all-application.Name`)}</th>
                              <th>{t(`all-application.Email Id`)}</th>
                              <th>{t(`all-application.Mobile No`)}</th>
                              <th>{t(`all-application.Gender`)}</th>
                              <th>{t(`all-application.Education`)}</th>
                              <th>{t(`all-application.Total Exp`)}</th>
                              <th>{t(`all-application.Job Role`)}</th>
                              <th>{t(`all-application.City`)}</th>
                              <th>{t(`all-application.Current Stage`)}</th>
                              <th>{t(`all-application.Actions`)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="10" className="text-center">
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>{t(`all-application.No Item Found`)}</h3>
                                  <p>
                                    {t(`all-application.Please modify filters`)}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isVisible && (
            <div className="filter-shadow filetr-cards">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Filters`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={toggleFilter}>
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="card-body allapplication-cards mb-3">
                  <Row>
                    {/* <Col md={12}>
                      <Form.Group>
                        <Form.Label className="float-label">
                          {t(`all-application.Gender`)}
                        </Form.Label>
                        <div className="application-button mb-3">
                          {filterData?.genderTypes?.map(item => {
                            return (
                              <div className="cat action">
                                <label>
                                  <input
                                    type="checkbox"
                                    name={item?.label}
                                    onChange={e =>
                                      handleGenderChange(
                                        e,
                                        item?.value,
                                        item?.id
                                      )
                                    }
                                    checked={
                                      filters?.gender?.find(
                                        el => el?.value === item?.value
                                      ) || false
                                    }
                                  />
                                  <span>{item?.label}</span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </Form.Group>
                    </Col> */}

                    <Col md={12}>
                      <Form.Group className="mb-3 floating-label">
                        <Form.Label className="float-label">
                          {t(`all-application.Job Title`)}
                        </Form.Label>
                        <div
                          title={
                            filters?.job_title?.length > 0
                              ? filters.job_title
                                  .map(item => item.label)
                                  .join(", ")
                              : `Please ${t(`all-application.Job Title`)}`
                          }
                        >
                          <MultiSelect
                            // shouldToggleOnHover={true}
                            id="job_title"
                            placeholder={t(`all-application.Select Job Title`)}
                            name="job_title"
                            value={filters?.job_title || []}
                            // isMulti
                            options={filterData?.jobTitles}
                            onChange={e => handleInput(e, "job_title")}
                            overrideStrings={{
                              selectSomeItems: `${t(
                                `all-application.Select Job Title`
                              )}`,
                            }}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Select Application Type`)}
                          </Form.Label>

                          <div
                            title={
                              filters?.application_type?.length > 0
                                ? filters.application_type
                                    .map(item => item.label)
                                    .join(", ")
                                : `Please ${t(
                                    `all-application.Select Application Type`
                                  )}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              id="application_type"
                              placeholder={t(
                                `all-applicaton.Select Application Type`
                              )}
                              name="application_type"
                              value={filters?.application_type || []}
                              // isMulti
                              options={[
                                {
                                  value: "all_applications",
                                  label: t(`all-applicaton.All Applications`),
                                },
                                {
                                  value: "my_applications",
                                  label: t(`all-application.My Applications`),
                                },
                              ]}
                              onChange={e => handleInput(e, "application_type")}
                              overrideStrings={{
                                selectSomeItems: `${t(
                                  `all-application.Select Application Type`
                                )}`,
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    )}
                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Application Stage`)}
                          </Form.Label>

                          <div
                            title={
                              filters?.application_stage?.length > 0
                                ? filters.application_stage
                                    .map(item => item.label)
                                    .join(", ")
                                : `Please ${t(
                                    `all-application.Application Stage`
                                  )}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              id="product_status"
                              placeholder={t(
                                `all-application.Select Application Stage`
                              )}
                              name="application_stage"
                              value={filters?.application_stage || []}
                              options={filterData?.applicationStages || []}
                              onChange={e =>
                                handleInput(e, "application_stage")
                              }
                              overrideStrings={{
                                selectSomeItems: `${t(
                                  `all-application.Select Application Stage`
                                )}`,
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    )}

                    {/* <Col md={12}>
                      <Form.Group className="mb-3 floating-label">
                        <Form.Label className="float-label">
                          {t(`all-application.Vacancy Type`)}
                        </Form.Label>

                        <div
                          title={
                            filters?.vacancy_type?.length > 0
                              ? filters.vacancy_type
                                  .map(item => item.label)
                                  .join(", ")
                              : `Please ${t(`all-application.Vacancy Type`)}`
                          }
                        >
                          <MultiSelect
                            // shouldToggleOnHover={true}
                            id="product_status"
                            placeholder={t(
                              `all-application.Select Vacancy Type`
                            )}
                            name="vacancy_type"
                            value={filters?.vacancy_type || []}
                            // isMulti
                            options={filterData?.vacancyTypes}
                            onChange={e => handleInput(e, "vacancy_type")}
                            overrideStrings={{
                              selectSomeItems: `${t(
                                `all-application.Select Vacancy Type`
                              )}`,
                            }}
                          />
                        </div>
                      </Form.Group>
                    </Col> */}
                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.City`)}
                          </Form.Label>

                          <div
                            title={
                              filters?.city?.length > 0
                                ? filters.city
                                    .map(item => item.label)
                                    .join(", ")
                                : `Please ${t(`all-application.City`)}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              id="city"
                              placeholder={t(`all-application.Select City`)}
                              name="city"
                              value={filters?.city || []}
                              // isMulti
                              options={filterData?.uniqueCities || []}
                              onChange={e => handleInput(e, "city")}
                              overrideStrings={{
                                selectSomeItems: `${t(
                                  `all-application.Select City`
                                )}`,
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    )}
                    <Col md={12}>
                      <Form.Group className="mb-3 floating-label">
                        <Form.Label className="float-label">
                          {t(`all-application.City`)}
                        </Form.Label>
                        <div style={{ position: "relative" }}>
                          {/* INPUT */}
                          <input
                            type="text"
                            placeholder="Search City"
                            value={searchText}
                            className="form-control"
                            onChange={e => handleSearchCity(e.target.value)}
                          />

                          {/* SELECTED CHIPS */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "5px",
                              gap: "5px",
                            }}
                          >
                            {(filters?.preferred_location || []).map(
                              (item, index) => (
                                <div
                                  key={index}
                                  style={{
                                    background: "#e6f0ff",
                                    padding: "5px 10px",
                                    borderRadius: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  {item.label}
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      const updated =
                                        filters.preferred_location.filter(
                                          el => el.value !== item.value
                                        );
                                      setFilters({
                                        ...filters,
                                        preferred_location: updated,
                                      });
                                    }}
                                  >
                                    ×
                                  </span>
                                </div>
                              )
                            )}
                          </div>

                          {/* DROPDOWN */}
                          {cityOptions.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "40px",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                maxHeight: "150px",
                                overflowY: "auto",
                                zIndex: 9999,
                              }}
                            >
                              {cityOptions.map((item, index) => {
                                const alreadySelected = (
                                  filters?.preferred_location || []
                                ).some(el => el.value === item.location);

                                return (
                                  <div
                                    key={index}
                                    style={{
                                      padding: "8px",
                                      cursor: "pointer",
                                      background: alreadySelected
                                        ? "#f5f5f5"
                                        : "#fff",
                                    }}
                                    onClick={() => {
                                      if (alreadySelected) return;

                                      const updated = [
                                        ...(filters?.preferred_location || []),
                                        {
                                          label: item.location,
                                          value: item.location,
                                        },
                                      ];

                                      setFilters({
                                        ...filters,
                                        preferred_location: updated,
                                      });

                                      setSearchText("");
                                      setCityOptions([]);
                                    }}
                                  >
                                    {item.location}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Hiring Source`)}
                          </Form.Label>

                          <div
                            title={
                              filters?.job_portal_name?.length > 0
                                ? filters.job_portal_name
                                    .map(item => item.label)
                                    .join(", ")
                                : `Please ${t(`all-application.Hiring Source`)}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              id="job_portal_name"
                              placeholder={t(
                                `all-application.Select Hiring Source`
                              )}
                              name="job_portal_name"
                              value={filters?.job_portal_name || []}
                              // isMulti
                              options={filterData?.sourceList || []}
                              onChange={e => handleInput(e, "job_portal_name")}
                              overrideStrings={{
                                selectSomeItems: `${t(
                                  `all-application.Select Hiring Source`
                                )}`,
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    )}

                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Required Expected Time`)}
                          </Form.Label>

                          <div
                            title={
                              filters?.expected_time?.length > 0
                                ? filters.expected_time
                                    .map(item => item.label)
                                    .join(", ")
                                : `Please ${t(
                                    `all-application.Required Expected Time`
                                  )}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              id="expected_time"
                              placeholder={t(
                                `all-application.Select Expected Time`
                              )}
                              name="expected_time"
                              value={filters?.expected_time || []}
                              // isMulti
                              options={filterData?.jobExpectedTimes || []}
                              onChange={e => handleInput(e, "expected_time")}
                              overrideStrings={{
                                selectSomeItems: `${t(
                                  `all-application.Select Expected Time`
                                )}`,
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    )}
                    {getSubdomain() !== "mahindra" && (
                      <Col md={12}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Relevancy Score`)}
                          </Form.Label>
                          <RangeSlider
                            progress
                            min={0}
                            max={100}
                            className="dual-range mt-3"
                            value={filters?.relevancy_score || []}
                            onChange={value => {
                              handleInput(value, "relevancy_score");
                            }}
                          />
                          <div className="d-flex justify-content-between mt-1">
                            <div className="mx-1">0</div>
                            <div className="mx-1">100</div>
                          </div>
                        </Form.Group>
                      </Col>
                    )}

                    <Col md={12}>
                      <Form.Group className="mb-3 floating-label">
                        <Form.Label className="float-label">
                          {t(`all-application.Age`)}
                        </Form.Label>
                        <RangeSlider
                          progress
                          min={18}
                          max={100}
                          className="dual-range mt-3"
                          value={filters?.age || []}
                          onChange={value => {
                            handleInput(value, "age");
                          }}
                        />
                        <div className="d-flex justify-content-between mt-1">
                          <div className="mx-1">18</div>
                          <div className="mx-1">100</div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="float-label">
                          {t(`all-application.Custom Date Range`)}
                        </Form.Label>
                        <div className="application-button mb-2">
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Current"}
                                onChange={e => {
                                  if (type === "curent") {
                                    setType("");
                                  } else {
                                    setType("current");
                                  }
                                }}
                                checked={type === "current"}
                              />
                              <span>{t(`all-application.Current`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Last 3 Months"}
                                onChange={e => {
                                  if (type === "previous") {
                                    setType("");
                                  } else {
                                    setType("previous");
                                  }
                                }}
                                checked={type === "previous"}
                              />
                              <span>{t(`all-application.Last 3 Months`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Custom"}
                                onChange={e => {
                                  if (type === "custom") {
                                    setType("");
                                  } else {
                                    setType("custom");
                                  }
                                }}
                                checked={type === "custom"}
                              />
                              <span>{t(`all-application.Custom`)}</span>
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    {type === "custom" && (
                      <>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.Start Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.Start Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setStartDate(e);
                              }}
                              placeholderText={t(`all-application.Start Date`)}
                              id="date"
                              selected={startDate}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.End Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.End Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setEndDate(e);
                              }}
                              placeholderText={t(`all-application.End Date`)}
                              id="date"
                              selected={endDate}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                  </Row>
                  <Row>
                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <button
                          onClick={clearFilters}
                          className="btn btn-primary reset"
                        >
                          {t(`all-application.Reset Filters`)}
                        </button>
                        <button
                          className="btn btn-primary"
                          disabled={loading}
                          onClick={() => handleSubmit()}
                        >
                          {loading && (
                            <>
                              <Spinner size={"sm"} />{" "}
                            </>
                          )}
                          {t(`all-application.Search Candidates`)}
                        </button>
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AllApplications;
